import { createContext } from 'react'

export type HeroModuleContextType = true

const HeroModuleContext = createContext<HeroModuleContextType | undefined>(
  undefined
)

export default HeroModuleContext
